import {
  Link,
  useLoaderData,
  useParams,
} from "@remix-run/react";
import clsx from "clsx";
import type { FunctionComponent } from "react";

import PostItem from "~/components/Post/PostItem";
import type { loader } from "./route";
import { usePaginteData } from "~/utils/hook/usePaginteData";
import { PR_COLORS } from "~/utils/const";

interface UserStoryPostsProps {}

export const UserStoryPosts: FunctionComponent<
  UserStoryPostsProps
> = () => {
  const param = useParams();
  const {
    userStoryPostsCursor: _userStoryPostsCursor,
  } = useLoaderData<typeof loader>();

  const { cursor: userStoryPosts } =
    usePaginteData(
      _userStoryPostsCursor,
      `/user/${param.userId}/story-load`,
    );

  return (
    <div className={clsx()}>
      <div
        className={clsx(
          "mb-24 flex items-center justify-between",
        )}
      >
        <h3
          className={clsx(
            "text-40 font-bold",
            "max-md:text-24",
          )}
        >
          STORY
        </h3>
        {
          <Link
            to={"/dashboard"}
            className={clsx(
              "text-14",
              "px-20",
              "py-8",
              "border",
              "border-gray-300",
              "rounded-full",
              "hover:bg-gray-50",
              "transition-colors",
            )}
          >
            ストーリーを書く
          </Link>
        }
      </div>

      {userStoryPosts.data.length === 0 && (
        <div className={clsx()}>
          <div
            className={clsx(
              "text-center",
              "text-gray-500",
            )}
          >
            ストーリーがありません
          </div>
        </div>
      )}

      <div className={clsx()}>
        <ul
          className={clsx(
            "grid",
            "grid-cols-3",
            "gap-16",
            "mt-24",
            "w-1300",
            "mx-auto",
            "gap-23",

            "max-md:flex",
            "max-md:flex-col",
            "max-md:gap-30",
            "max-md:w-360",
            "max-md:mr-0",
          )}
        >
          {userStoryPosts.data
            ?.slice(0, 3)
            .map((el, i) => {
              return (
                <li key={i} className={clsx("")}>
                  <PostItem
                    color={
                      PR_COLORS[
                        i % PR_COLORS.length
                      ]
                    }
                    data={el}
                  ></PostItem>
                </li>
              );
            })}
        </ul>
      </div>
      {/*    {userStoryPosts.data.length >= 1 && (
        <div
          className={clsx("text-center", "mt-60")}
        >
          <Link
            to={`/posts/story/${param.userId}`}
            className={clsx(
              "bg-red",
              buttonBase({
                size: "md",
                round: "full",
                variant: "default",
              }),
            )}
            onClick={() => {
              nextLoad();
            }}
          >
            もっと見る
          </Link>
        </div>
      )} */}
    </div>
  );
};
